export function elementToggle(
    containerClass,
    triggerClass,
    activeClass,
    effect
) {
    $(document).on("click", triggerClass, function (e) {
        const element = $(this).siblings(containerClass);
        if (element.length === 0) return;

        $(containerClass).not(element).fadeOut().removeClass(activeClass);

        if (effect === "slide") {
            element.slideToggle();
        } else {
            element.fadeToggle();
        }
        element.toggleClass(activeClass);
        e.stopPropagation();
    });

    $(document).on("click", containerClass, function (e) {
        e.stopPropagation();
    });

    $(document).on("click", function () {
        $(containerClass + `.${activeClass}`)
            .fadeOut()
            .removeClass(activeClass);
    });
}
